export interface ImageUploadValidationResult {
    readonly isValid: boolean;
    readonly message: string | null;
}

const bytesPerMegabyte = 1024 * 1024;
const defaultMaxFileSizeMb = 10;

export const defaultMaxImageFileSizeBytes = defaultMaxFileSizeMb * bytesPerMegabyte;

export const supportedImageExtensions = new Set<string>([
    'gif',
    'jpeg',
    'jpg',
    'jiff',
    'png',
    'svg',
    'tiff'
]);

export class ImageUploadValidator {
    /**
     * Validates image extension and size before uploading it to the backend.
     */
    public static validate(file: File, maxFileSizeBytes = defaultMaxImageFileSizeBytes): ImageUploadValidationResult {
        const extension = ImageUploadValidator.getExtension(file.name);

        if (!supportedImageExtensions.has(extension)) {
            return {
                isValid: false,
                message: 'Formato de imagen no válido.'
            };
        }

        if (file.size > maxFileSizeBytes) {
            return {
                isValid: false,
                message: `La imagen supera el tamaño máximo permitido (${ImageUploadValidator.formatBytes(maxFileSizeBytes)}).`
            };
        }

        return {
            isValid: true,
            message: null
        };
    }

    private static getExtension(fileName: string): string {
        return fileName.split('.').pop()?.toLowerCase() ?? '';
    }

    private static formatBytes(bytes: number): string {
        const sizeInMb = bytes / bytesPerMegabyte;

        return `${sizeInMb.toFixed(0)} MB`;
    }
}
